import { IfpEligibilityType } from '../../../typings';

export const getSelectedLineNumberDetailsBasedOnPlans = (
  ifpEligibility: IfpEligibilityType,
) => {
  if (!ifpEligibility?.eligibility) {
    return null;
  }
  const { selectedLineNumber, eligibility } = ifpEligibility;
  const lines = [
    ...eligibility?.eligibleLines,
    ...eligibility?.ineligibleLines,
  ];
  return lines.find((line) => line.lineNumber === selectedLineNumber);
};
